import { useKeymap } from "@features/keymap/useKeymap"
import { KeyBinding } from "@features/keymap/KeyBinding"
import { InfoOutlined } from "@mui/icons-material"
import { useSetAtom } from "jotai"
import { ControlButton } from "reactflow"
import {
  ActiveShortcutsInfoDialog,
  openShortcutsInfoDialogAtom,
} from "@components/ActiveShortcutsInfoDialog"
import { shortcuts } from "@features/keymap/shortcuts"

export const ActiveShortcutsInfoButton = () => {
  const keymap = useKeymap()
  const setOpen = useSetAtom(openShortcutsInfoDialogAtom)

  const handleToggle = () => setOpen((v) => !v)

  return (
    <>
      <KeyBinding bind={shortcuts["view-shortcuts"]} onKeyDown={handleToggle} />
      <ControlButton
        data-testid="graph-controls-active-shortcuts-info-btn"
        onClick={handleToggle}
        title={keymap.getKeymaps().byId.get("view-shortcuts")?.desc}
      >
        <InfoOutlined />
      </ControlButton>
      <ActiveShortcutsInfoDialog />
    </>
  )
}
